export const CONTENT = {
  successMessage: 'Thanks for signing up!',
  merchandisingMessage:
    'Sign up for email-only coupons, special offers and promotions — exclusively from Priceline.',
  placeHolder: 'example@address.com',
  errorMessage: 'Please enter a valid email',
  buttonText: 'Send me deals',
  buttonSubmittingText: 'Submitting'
}

export const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
